import { render, staticRenderFns } from "./copyWares.vue?vue&type=template&id=62cfd360&scoped=true&"
import script from "./copyWares.vue?vue&type=script&lang=js&"
export * from "./copyWares.vue?vue&type=script&lang=js&"
import style0 from "./copyWares.vue?vue&type=style&index=0&id=62cfd360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cfd360",
  null
  
)

export default component.exports